import React from "react"
import Footer from "../components/Footer"

const FooterView = () => {
  return (
    <Footer>
      <div>Hand crafted with React, Styled Components and Framer Motion</div>
      {/*
      <div>
        Icons made by <a href="https://www.flaticon.com/authors/pixel-perfect" title="Pixel perfect">Pixel perfect</a> from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
      </div>
      */}
    </Footer>
  )
}

export default FooterView